import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  min-width: 1140px;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const FeatureTitle = styled.div`
  display: flex;
  padding: 20px 28px;
  align-items: center;
  align-self: stretch;
`;

export const FeatureSetting = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const FeatureActivation = styled.div`
  display: flex;
  padding: 20px 28px 20px 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-bottom: 2px solid var(--alias-color-line-alternative);

  .article {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const FeatureChannelSetting = styled.div`
  display: flex;
  padding: 20px 28px 20px 56px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  .article {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
  }
`;

export const Channel = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  .item {
    display: flex;
    align-items: center;
    gap: 4px;

    cursor: pointer;
  }
`;

export const Line = styled.div`
  height: 4px;
  width: 100%;
  background-color: var(--alias-color-line-normal);
`;
